import type { TypedDataSigner } from '@ethersproject/abstract-signer'
import { Signer, ethers } from 'ethers'
import { Action } from './Action'
import { Category } from './Category'

/**
 * Client-side class that contains a request to be signed
 */
export class SignableRequest {
  /**
   * Initialize request
   * @param signer EthersJS signer used to sign request
   * @param networkId ID of the blockchain where the action is to be performed
   * @param account Checksum address of the user requesting the action
   * @param category Product category, e.g. 'trophy' or 'card'
   * @param id Product ID
   * @param action Action to be performed, e.g. 'mint' a product
   */
  constructor (
    public readonly signer: Signer & TypedDataSigner,
    public readonly networkId: number,
    public readonly account: string,
    public readonly category: Category,
    public readonly id: string,
    public readonly action: Action
  ) {
    this.signer = signer
    this.networkId = networkId
    this.account = ethers.utils.getAddress(account)
    this.category = category
    this.id = id
    this.action = action
  }
}
